import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const FeaturedCategories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      name: 'Face Care',
      icon: 'Droplet',
      description: 'Cleanse & Refresh',
      color: 'from-rose-500/20 to-pink-500/20',
      iconColor: 'text-rose-600'
    },
    {
      name: 'Body Bar',
      icon: 'Sparkles',
      description: 'Handmade Naturally',
      color: 'from-amber-500/20 to-orange-500/20',
      iconColor: 'text-amber-600'
    },
    {
      name: 'Intimate Care',
      icon: 'Heart',
      description: 'Gentle & Honest',
      color: 'from-fuchsia-500/20 to-pink-500/20',
      iconColor: 'text-fuchsia-600'
    },
    {
      name: 'Shop All',
      icon: 'ShoppingBag',
      description: 'Browse Everything',
      color: 'from-emerald-500/20 to-teal-500/20',
      iconColor: 'text-emerald-600'
    }
  ];

  const handleCategoryClick = (category) => {
    navigate('/product-catalog', { state: { category: category?.name } });
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4"
          >
            Shop by Category
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
          >
            Explore our carefully curated collections designed for every beauty need
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories?.map((category, index) => (
            <motion.div
              key={category?.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              onClick={() => handleCategoryClick(category)}
              className="cursor-pointer"
            >
              <div className={`relative overflow-hidden rounded-2xl bg-gradient-to-br ${category?.color} p-8 h-full border border-border hover:border-primary/50 transition-all duration-300 shadow-lg hover:shadow-xl`}>
                <div className="relative z-10">
                  <div className={`${category?.iconColor} mb-4`}>
                    <Icon name={category?.icon} size={48} />
                  </div>
                  <h3 className="text-2xl font-heading font-semibold text-foreground mb-2">
                    {category?.name}
                  </h3>
                  <p className="text-muted-foreground">
                    {category?.description}
                  </p>
                </div>
                <div className="absolute -bottom-4 -right-4 opacity-10">
                  <Icon name={category?.icon} size={120} />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCategories;